import React, { useEffect, useState, useContext, useRef } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { APIAgentKYCStatus as AgentKYCStatus } from 'Components/Api/EzyPayAEPSAPI';
import { MerchantActivation as MERCHANT_ACTIVATE } from 'Components/Api/EzyPayAEPSAPI';
import { Typography } from '@mui/material';
import Box from '@material-ui/core/Box';
import { useHistory } from 'react-router-dom';

import {
    Container,
    Grid,
    Paper,
    TextField,
    Button,
    CircularProgress
} from '@material-ui/core';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';

import { PrimaryButton } from 'Components/Inputes/CustomButton';
import HOCLoader from 'Components/Loader/HOCLoader';
import { FailTransactionResponse } from 'Components/Alert/FailTransactionResponse';
const CustomContainer = HOCLoader(Container);

export const APIAgentKYC = () => {
    const classes = commonStyle();
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [ImagePAN, setPANImage] = useState('');
    const [AadharImageFront, setAadharFrontImage] = useState('');
    const [AadharImageBack, setAadharBackImage] = useState('');
    const [isAlertErrorOpen, setIsAlertErrorOpen] = useState(false);
    const [Message, setMessage] = useState('');
    const [status, setStatus] = useState('PROCESS');
    const [kycStatusText, setKycStatusText] = useState('');
    const history = useHistory();
    const [PANImageDimension] = useState({
        width: 300,
        height: 300
    });
    const [AadharFrontImageDimension] = useState({
        width: 300,
        height: 300
    });

    const [AadharBackImageDimension] = useState({
        width: 300,
        height: 300
    });

    const [FormObj, setFormObj] = useState({
        PANImage: {
            Name: '',
            Size: '',
            Type: '',
            Data: ''
        },

        AadharFrontImage: {
            Name: '',
            Size: '',
            Type: '',
            Data: ''
        },

        AadharBackImage: {
            Name: '',
            Size: '',
            Type: '',
            Data: ''
        }
    });

    const FormValidationSchema = Yup.object({});

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        var requestObj = JSON.stringify(values);
        const { isAuthorized, status, data } = await MERCHANT_ACTIVATE(
            requestObj
        );
        if (!isAuthorized) LOGOUT();

        if (!status) {
            return;
        }
        var response = JSON.parse(data);

        if (!data.status) {
            if (response.status === 'Failure') {
                setResponseMessage(response.Message);
                setSeverity('error');
                setIsError(true);
            }

            setStatus('PROCESS');
            setMessage(response.Message);
            setSeverity('success');
            setIsAlertErrorOpen(true);

            return;
        }
        setIsError(true);
        setSeverity('success');
        setResponseMessage(response.Message);

        resetForm(FormObj);

        setFormObj({
            ...FormObj,
            PANImage: {
                Name: '',
                Size: '',
                Type: '',
                Data: ''
            },

            AadharFrontImage: {
                Name: '',
                Size: '',
                Type: '',
                Data: ''
            },

            AadharBackImage: {
                Name: '',
                Size: '',
                Type: '',
                Data: ''
            }
        });
    };
    const CheckAgentKYCStatus = async () => {
        setResponseMessage('');
        const response = await AgentKYCStatus();
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();
        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.Message);
            return;
        }
        const data = JSON.parse(response.data);
        setKycStatusText(data.Message  || '');
        if (data.IsAPiAgentKyc) {
            history.push('/EPayOnboardingForAirtel');
            return;
        }

    };
    useEffect(() => {
        CheckAgentKYCStatus();
    }, []);


    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            {/* Show KYC status on top */}

            <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <h2 className={classes.PaperHead_h2}>Merchant Activation</h2>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <h4>
                        Each KYC file must be below 200 KB in size and in JPG format.
                    </h4>
                </Grid>
            </Grid>

            <Formik
                enableReinitialize={true}
                initialValues={FormObj}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
            >
                {({ setFieldValue }) => {
                    const handleImageUpload = (event, fieldName, setPreviewImage) => {
                        const file = event.target.files[0];
                        if (!file) return;

                        setPreviewImage(URL.createObjectURL(file));

                        setFieldValue(`${fieldName}.Name`, file.name);
                        setFieldValue(`${fieldName}.Size`, file.size);
                        setFieldValue(`${fieldName}.Type`, file.type);

                        const reader = new FileReader();
                        reader.onload = ({ target: { result } }) => {
                            const base64 = result.replace(/^data:.+;base64,/, '');
                            setFieldValue(`${fieldName}.Data`, base64);
                        };
                        reader.readAsDataURL(file);
                    };
                    return (
                        <Form>
                            {kycStatusText && (
                                <Box
                                    mb={2}
                                    p={1.5}
                                    bgcolor="#e3f2fd"       // Light blue background, soft and calming
                                    borderRadius={6}
                                    border="1px solid #90caf9"  // Medium blue border
                                    textAlign="center"
                                >
                                    <Typography
                                        variant="subtitle1"
                                        style={{ fontWeight: '600', color: '#1565c0' }} // Darker blue text for good contrast
                                    >
                                        Document Status: {kycStatusText}
                                    </Typography>
                                </Box>
                            )}
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={3}>
                                        {/* Aadhar Front */}
                                        <Grid item xs={12} md={4}>
                                            <label htmlFor="aadhar-front">Aadhar Image Front</label>
                                            <TextField
                                                id="aadhar-front"
                                                type="file"
                                                inputProps={{ accept: 'image/*' }}
                                                fullWidth
                                                onChange={(e) =>
                                                    handleImageUpload(
                                                        e,
                                                        'AadharFrontImage',
                                                        setAadharFrontImage
                                                    )
                                                }
                                            />
                                            {AadharImageFront && (
                                                <Box mt={1}>
                                                    <img
                                                        src={AadharImageFront}
                                                        alt="Aadhar Front"
                                                        width="100%"
                                                        height={AadharFrontImageDimension.height}
                                                        style={{ borderRadius: 8, border: '1px solid #ccc' }}
                                                    />
                                                </Box>
                                            )}
                                        </Grid>

                                        {/* Aadhar Back */}
                                        <Grid item xs={12} md={4}>
                                            <label htmlFor="aadhar-back">Aadhar Image Back</label>
                                            <TextField
                                                id="aadhar-back"
                                                type="file"
                                                inputProps={{ accept: 'image/*' }}
                                                fullWidth
                                                onChange={(e) =>
                                                    handleImageUpload(
                                                        e,
                                                        'AadharBackImage',
                                                        setAadharBackImage
                                                    )
                                                }
                                            />
                                            {AadharImageBack && (
                                                <Box mt={1}>
                                                    <img
                                                        src={AadharImageBack}
                                                        alt="Aadhar Back"
                                                        width="100%"
                                                        height={AadharBackImageDimension.height}
                                                        style={{ borderRadius: 8, border: '1px solid #ccc' }}
                                                    />
                                                </Box>
                                            )}
                                        </Grid>

                                        {/* PAN */}
                                        <Grid item xs={12} md={4}>
                                            <label htmlFor="pan">PAN Image</label>
                                            <TextField
                                                id="pan"
                                                type="file"
                                                inputProps={{ accept: 'image/*' }}
                                                fullWidth
                                                onChange={(e) =>
                                                    handleImageUpload(e, 'PANImage', setPANImage)
                                                }
                                            />
                                            {ImagePAN && (
                                                <Box mt={1}>
                                                    <img
                                                        src={ImagePAN}
                                                        alt="PAN"
                                                        width="100%"
                                                        height={PANImageDimension.height}
                                                        style={{ borderRadius: 8, border: '1px solid #ccc' }}
                                                    />
                                                </Box>
                                            )}
                                        </Grid>
                                    </Grid>

                                    <Grid container justifyContent="flex-end" spacing={2} mt={3}>
                                        <Grid item xs={12} md={2}>
                                            <Box width="100%">
                                                <div className={classes.SubmitWrapper}>
                                                    <PrimaryButton
                                                        type="submit"
                                                        title="Activate"
                                                        size="medium"
                                                        fullWidth
                                                        className={classes.CustomPrimaryButtonStyle}
                                                        disabled={loadingOpen}
                                                    >
                                                        Activate
                                                    </PrimaryButton>
                                                    {loadingOpen && (
                                                        <CircularProgress
                                                            size={24}
                                                            className={classes.buttonProgress}
                                                            style={{
                                                                position: 'absolute',
                                                                marginLeft: -30,
                                                                marginTop: 10
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>

            {isAlertErrorOpen && (
                <FailTransactionResponse
                    isOpen={isAlertErrorOpen}
                    title={status}
                    Message={Message}
                    OkButtonClick={() => setIsAlertErrorOpen(false)}
                />
            )}
        </CustomContainer>
    );

};
